/**
 * @generated SignedSource<<c91a5cc32453f5c27ef788f6f30619ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UrlMappingListTabContainer_user$data = {
  readonly enableBackendUrlMapping: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"UrlMappingListTab_user">;
  readonly " $fragmentType": "UrlMappingListTabContainer_user";
};
export type UrlMappingListTabContainer_user = UrlMappingListTabContainer_user$data;
export type UrlMappingListTabContainer_user$key = {
  readonly " $data"?: UrlMappingListTabContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UrlMappingListTabContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UrlMappingListTabContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableBackendUrlMapping",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UrlMappingListTab_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cb8ba0e9e5fbbf001bf0440680d30118";

export default node;
